<template>
    <div class="location-list-view">
        <h1 class="app-h1">
            Места проведения
        </h1>

        <div class="location-list-view__toolbar">
            <el-input
                v-model.trim="search"
                class="location-list-view__search"
                clearable
                placeholder="Поиск"
            />

            <el-button
                type="primary"
                @click="_openAddForm"
            >
                Добавить
            </el-button>
        </div>

        <location-list
            ref="list"
            :search="search"
            @edit="_onLocationEdit"
        />

        <location-form-popup
            ref="form"
            @added="_onLocationAdded"
            @updated="_onLocationUpdated"
        />
    </div>
</template>

<script>
import breadcrumbs from '@/mixins/breadcrumbs';
import { ROUTES } from '@/enums';
import LocationList from '@/modules/location/components/LocationList';
import LocationFormPopup from '@/modules/location/components/LocationFormPopup';

export default {
    name: 'LocationListView',

    components: {
        LocationList,
        LocationFormPopup
    },

    mixins: [
        breadcrumbs
    ],

    data() {
        return {
            search: ''
        };
    },

    computed: {
        $breadcrumbs() {
            return [
                {
                    title: 'Услуги',
                    route: null
                },
                {
                    title: 'Места проведения',
                    route: ROUTES.LOCATION.LIST
                }
            ];
        }
    },

    methods: {
        _openAddForm() {
            this.$refs.form.open();
        },

        _onLocationEdit({ location }) {
            this.$refs.form.open(location);
        },

        _onLocationAdded({ location }) {
            this.$message.success(`Место проведения "${location.attributes.title}" добавлено успешно`);
            this.$refs.list.reload();
        },

        _onLocationUpdated({ location }) {
            this.$message.success(`Место проведения "${location.attributes.title}" обновлено успешно`);
            this.$refs.list.reload();
        }
    }
};
</script>

<style lang="scss">
@import "@vars";

.location-list-view {
    &__toolbar {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
    }

    &__search {
        max-width: 300px;
        width: 100%;
    }
}
</style>
